function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Return an HTML5 audio player with the given src URL.
 */
function audioElement(src) {
  var html5audio = document.createElement('audio');
  html5audio.controls = true;
  html5audio.src = src;
  return html5audio;
}

/**
 * Wrap an element in a container that causes the element to be displayed at
 * a given aspect ratio.
 *
 * See https://css-tricks.com/aspect-ratio-boxes/.
 *
 * @param element
 * @param aspectRatio - Aspect ratio as `width/height`
 * @return - A container element which wraps `element`
 */
function wrapInAspectRatioContainer(element, aspectRatio) {
  element.style.position = 'absolute';
  element.style.top = '0';
  element.style.left = '0';
  element.style.width = '100%';
  element.style.height = '100%';
  var container = document.createElement('div');
  container.style.paddingBottom = "".concat(1 / aspectRatio * 100, "%");
  container.style.position = 'relative';
  container.appendChild(element);
  return container;
}

/**
 * Return an iframe DOM element with the given src URL.
 */
function iframe(src) {
  var aspectRatio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16 / 9;
  var iframe_ = document.createElement('iframe');
  iframe_.src = src;
  iframe_.setAttribute('frameborder', '0');
  iframe_.setAttribute('allowfullscreen', '');
  return wrapInAspectRatioContainer(iframe_, aspectRatio);
}

/**
 * Return timeValue as a value in seconds, supporting `t` param's optional
 * '\dh\dm\ds' format. If `timeValue` is numeric (only),
 * it's assumed to be seconds and is left alone.
 *
 * @param timeValue - value of `t` or `start` param in YouTube URL
 * @return timeValue in seconds
 * @example
 * formatYouTubeTime('5m'); // returns '300'
 * formatYouTubeTime('20m10s'); // returns '1210'
 * formatYouTubeTime('1h1s'); // returns '3601'
 * formatYouTubeTime('10'); // returns '10'
 **/
function parseTimeString(timeValue) {
  var timePattern = /(\d+)([hms]?)/g;
  var multipliers = {
    h: 60 * 60,
    m: 60,
    s: 1
  };
  var seconds = 0;
  var match;
  // match[1] - Numeric value
  // match[2] - Unit (e.g. 'h','m','s', or empty)
  while ((match = timePattern.exec(timeValue)) !== null) {
    if (match[2]) {
      var unit = match[2];
      seconds += Number(match[1]) * multipliers[unit];
    } else {
      seconds += +match[1]; // Treat values missing units as seconds
    }
  }
  return seconds.toString();
}

/**
 * Return a YouTube URL query string containing (only) whitelisted params.
 * See https://developers.google.com/youtube/player_parameters for
 * all parameter possibilities.
 *
 * @return Formatted filtered URL query string, e.g. '?start=90' or
 *   an empty string if the filtered query is empty.
 * @example
 * // returns '?end=10&start=5'
 * youTubeQueryParams(link); // where `link.search` = '?t=5&baz=foo&end=10'
 * // - `t` is translated to `start`
 * // - `baz` is not allowed param
 * // - param keys are sorted
 */
function youTubeQueryParams(link) {
  var allowedParams = ['end', 'start', 't' // will be translated to `start`
  ];
  var linkParams = new URLSearchParams(link.search);
  var filteredQuery = new URLSearchParams();

  // Copy allowed params into `filteredQuery`.
  var _iterator = _createForOfIteratorHelper(linkParams),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        key = _step$value[0],
        value = _step$value[1];
      if (!allowedParams.includes(key)) {
        continue;
      }
      if (key === 't') {
        // `t` is not supported in embeds; `start` is
        // `t` accepts more formats than `start`; start must be in seconds
        // so, format it as seconds first
        filteredQuery.append('start', parseTimeString(value));
      } else {
        filteredQuery.append(key, value);
      }
    }

    // Tests currently expect sorted parameters.
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  filteredQuery.sort();
  var query = filteredQuery.toString();
  if (query) {
    query = "?".concat(query);
  }
  return query;
}

/**
 * Return a YouTube embed (<iframe>) DOM element for the given video ID.
 */
function youTubeEmbed(id, link) {
  var query = youTubeQueryParams(link);
  return iframe("https://www.youtube.com/embed/".concat(id).concat(query));
}

/**
 * Create an iframe embed generator for links that have the form
 * `https://<hostname>/<path containing a video ID>`
 *
 * @param pathPattern -
 *   Pattern to match against the pathname part of the link. This regex should
 *   contain a single capture group which matches the video ID within the path.
 * @param iframeUrlGenerator -
 *   Generate the URL for an embedded video iframe from a video ID
 * @return Function that takes an `<a>` element and returns the embedded iframe
 *   for that link, or `null` if we don't have a matching embed generator.
 */
function createEmbedGenerator(hostname, pathPattern, iframeUrlGenerator) {
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
    aspectRatio = _ref.aspectRatio;
  var generator = function generator(link) {
    if (link.hostname !== hostname) {
      return null;
    }
    var groups = pathPattern.exec(link.pathname);
    if (!groups) {
      return null;
    }
    var id = groups[1];
    return iframe(iframeUrlGenerator(id), aspectRatio);
  };
  return generator;
}

/**
 * A list of functions that return an "embed" DOM element (e.g. an <iframe> or
 * an html5 <audio> element) for a given link.
 *
 * Each function either returns `undefined` if it can't generate an embed for
 * the link, or a DOM element if it can.
 */
var embedGenerators = [
// Matches URLs like https://www.youtube.com/watch?v=rw6oWkCojpw
function iframeFromYouTubeWatchURL(link) {
  if (link.hostname !== 'www.youtube.com') {
    return null;
  }
  if (!/\/watch\/?/.test(link.pathname)) {
    return null;
  }
  var groups = /[&?]v=([^&#]+)/.exec(link.search);
  if (groups) {
    return youTubeEmbed(groups[1], link);
  }
  return null;
},
// Matches URLs like https://youtu.be/rw6oWkCojpw
function iframeFromYouTubeShareURL(link) {
  if (link.hostname !== 'youtu.be') {
    return null;
  }

  // extract video ID from URL
  var groups = /^\/([^/]+)\/?$/.exec(link.pathname);
  if (groups) {
    return youTubeEmbed(groups[1], link);
  }
  return null;
},
// Matches URLs like https://vimeo.com/149000090
createEmbedGenerator('vimeo.com', /^\/([^/?#]+)\/?$/, function (id) {
  return "https://player.vimeo.com/video/".concat(id);
}),
// Matches URLs like https://vimeo.com/channels/staffpicks/148845534
createEmbedGenerator('vimeo.com', /^\/channels\/[^/]+\/([^/?#]+)\/?$/, function (id) {
  return "https://player.vimeo.com/video/".concat(id);
}),
/**
 * Match Internet Archive URLs
 *
 *  The patterns are:
 *
 *  1. https://archive.org/embed/{slug}?start={startTime}&end={endTime}
 *     (Embed links)
 *
 *  2. https://archive.org/details/{slug}?start={startTime}&end={endTime}
 *     (Video page links for most videos)
 *
 *  3. https://archive.org/details/{slug}/start/{startTime}/end/{endTime}
 *     (Video page links for the TV News Archive [1])
 *
 *  (2) and (3) allow users to copy and paste URLs from archive.org video
 *  details pages directly into the sidebar to generate video embeds.
 *
 *  [1] https://archive.org/details/tv
 */
function iFrameFromInternetArchiveLink(link) {
  if (link.hostname !== 'archive.org') {
    return null;
  }

  // Extract the unique slug from the path.
  var slugMatch = /^\/(embed|details)\/(.+)/.exec(link.pathname);
  if (!slugMatch) {
    return null;
  }

  // Extract start and end times, which may appear either as query string
  // params or path params.
  var slug = slugMatch[2];
  var linkParams = new URLSearchParams(link.search);
  var startTime = linkParams.get('start');
  var endTime = linkParams.get('end');
  if (!startTime) {
    var startPathParam = slug.match(/\/start\/([^/]+)/);
    if (startPathParam) {
      startTime = startPathParam[1];
      slug = slug.replace(startPathParam[0], '');
    }
  }
  if (!endTime) {
    var endPathParam = slug.match(/\/end\/([^/]+)/);
    if (endPathParam) {
      endTime = endPathParam[1];
      slug = slug.replace(endPathParam[0], '');
    }
  }

  // Generate embed URL.
  var iframeUrl = new URL("https://archive.org/embed/".concat(slug));
  if (startTime) {
    iframeUrl.searchParams.append('start', startTime);
  }
  if (endTime) {
    iframeUrl.searchParams.append('end', endTime);
  }
  return iframe(iframeUrl.href);
},
// Matches URLs that end with .mp3, .ogg, or .wav (assumed to be audio files)
function html5audioFromMp3Link(link) {
  if (link.pathname.endsWith('.mp3') || link.pathname.endsWith('.ogg') || link.pathname.endsWith('.wav')) {
    return audioElement(link.href);
  }
  return null;
}];

/**
 * Return an embed element for the given link if it's an embeddable link.
 *
 * If the link is a link for a YouTube video or other embeddable media then
 * return an embed DOM element (for example an <iframe>) for that media.
 */
function embedForLink(link) {
  var embed;
  var j;
  for (j = 0; j < embedGenerators.length; j++) {
    embed = embedGenerators[j](link);
    if (embed) {
      return embed;
    }
  }
  return null;
}

/**
 * Replace the given link element with an embed.
 *
 * If the given link element is a link to an embeddable media and if its link
 * text is the same as its href then it will be replaced in the DOM with an
 * embed (e.g. an <iframe> or html5 <audio> element) of the same media.
 *
 * If the link text is different from the href, then the link will be left
 * untouched. We want to convert links like these from the Markdown source into
 * embeds:
 *
 *     https://vimeo.com/channels/staffpicks/148845534
 *     <https://vimeo.com/channels/staffpicks/148845534>
 *
 * But we don't want to convert links like this:
 *
 *     [Custom link text](https://vimeo.com/channels/staffpicks/148845534)
 *
 * because doing so would destroy the user's custom link text, and leave users
 * with no way to just insert a media link without it being embedded.
 *
 * If the link is not a link to an embeddable media it will be left untouched.
 */
function replaceLinkWithEmbed(link) {
  // The link's text may or may not be percent encoded. The `link.href` property
  // will always be percent encoded. When comparing the two we need to be
  // agnostic as to which representation is used.
  if (link.href !== link.textContent) {
    try {
      var encodedText = encodeURI(link.textContent);
      if (link.href !== encodedText) {
        return null;
      }
    } catch (_unused) {
      return null;
    }
  }
  var embed = embedForLink(link);
  if (embed) {
    link.parentElement.replaceChild(embed, link);
  }
  return embed;
}
/**
 * Replace all embeddable link elements beneath the given element with embeds.
 *
 * All links to YouTube videos or other embeddable media will be replaced with
 * embeds of the same media.
 *
 * @param element - Root element to search for links
 */
export function replaceLinksWithEmbeds(element) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    className = _ref2.className;
  // Get a static (non-live) list of <a> children of `element`.
  // It needs to be static because we may replace these elements as we iterate over them.
  var links = Array.from(element.getElementsByTagName('a'));
  for (var _i = 0, _links = links; _i < _links.length; _i++) {
    var link = _links[_i];
    var embed = replaceLinkWithEmbed(link);
    if (embed) {
      if (className) {
        embed.className = className;
      } else {
        // Default width.
        embed.style.width = '350px';
      }
    }
  }
}
//# sourceMappingURL=media-embedder.js.map